import styled from 'styled-components';
import { ScFormGroup } from '@/components/form/groups/styled';
import { ThemeMode } from '@/helpers/enums';
import { device } from '@/styles/helpers';

interface FieldProps {
  mode?: ThemeMode;
}

export const ScFieldExpiryDateRow = styled.div<{ $list?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $list }) =>
    $list ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'};
  grid-column-gap: 16px;
  grid-row-gap: 16px;
`;

export const ScFieldBanner = styled.div<FieldProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;

  & span {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0em;
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobileS}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }

  & > svg {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;

    path {
      fill: ${({ theme, mode }) =>
        mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
    }
  }

  .payments-js-lib {
    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__img-wrapper {
      display: none;
    }

    &__description {
      font-size: 12px;
      line-height: 18px;
    }
  }
`;

export const ScFieldBannerOld = styled.div`
  .payments-js-lib {
    &__wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: 24px 0;
    }
    &__img-wrapper {
    }
    &__description {
      padding-left: 16px;
      font-size: 14px;
      @media (${device.mobile}) {
        font-size: 12px;
      }
    }
  }
`;

export const ScCryptoBlock = styled.div<FieldProps>`
  &,
  .info {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .info {
    gap: 12px;
    margin-bottom: 24px;
    padding: 0 16px;

    .info-inner {
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        font-size: 20px;
        object-fit: contain;
        flex-shrink: 0;
        color: ${({ theme, mode }) =>
          mode === ThemeMode.Dark ? theme.whiteColor : theme.blackColor};
      }

      b,
      span {
        font-size: 12px;
        line-height: 18px;
      }
    }
  }

  ${ScFormGroup} {
    margin-bottom: 4px;
  }
`;
